document.addEventListener("DOMContentLoaded", function () {
  var tabTitles = document.querySelectorAll(
    ".cstm-collection-tab-filter-title"
  );
  tabTitles.forEach(function (title) {
    tabTitles[0].querySelector(".title_tab_heading").classList.add("selected");
    title.addEventListener("click", function () {
      var getID = title.getAttribute("id");
      var value = title.getAttribute("value");
      var currentURL = "https://horlickin.myshopify.com" + value;
      $(".title_tab_heading").removeClass("selected");
      $(this).find(".title_tab_heading").addClass("selected");
      var tabIdValue = title.id;
      var productGridItems = document.querySelectorAll(
        ".cstm_product_grid_container ul.product-grid li"
      );
      productGridItems.forEach(function (item) {
        if (tabIdValue === "all" || item.id === tabIdValue) {
          item.style.display = "block";
        } else {
          item.style.display = "none";
        }
      });
    });
  });
});
//-----code to extract hash value from url starts-----//
$(document).ready(function () {
  var hashValue = window.location.href.split("#")[1].toLowerCase();
  var tabHeadings = document.querySelectorAll(
    ".cstm-collection-tab-filter-title a"
  );
  // $(".cstm_product_grid_container .grid__item").hide();
  // $(`[data-target="${hashValue}"]`).show();
  tabHeadings.forEach(function (anchor) {
    if (anchor.href && anchor.href.includes(hashValue)) {
      anchor.classList.add("selected");
      anchor.click();
    }
  });
});
//-----code to extract hash value from url ends-----//
